import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Palmtree } from "lucide-react";
import api, { formatError } from "@/lib/api";

const inp = "bg-slate-900 border border-slate-600 rounded-lg px-2 py-1.5 text-sm";

export default function HolidaySettings() {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/admin/holiday").then(({ data }) => setF(data)).catch(() => {}); }, []);
  if (!f) return null;
  const set = (k) => (e) => setF({ ...f, [k]: Number(e.target.value) });
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.post("/admin/holiday", { price: f.price, per_subject: f.per_subject, next_per_subject: f.next_per_subject, spots: f.spots }); setF({ ...f, ...data }); toast.success("Holiday pack saved"); }
    catch (e) { toast.error(formatError(e.response?.data?.detail) || e.message); } finally { setBusy(false); }
  };
  const field = (label, k, type) => (
    <label className="flex flex-col gap-1 text-xs text-slate-400">{label}
      <input type={type} value={f[k]} onChange={set(k)} className={`${inp} ${type === "number" ? "w-24" : ""}`} data-testid={`holiday-setting-${k}`} />
    </label>
  );
  return (
    <div className="bg-slate-800 rounded-2xl border-2 border-orange-400/50 p-4 flex flex-wrap items-end gap-3 mb-4" data-testid="admin-holiday-settings">
      <p className="w-full font-bold flex items-center gap-2"><Palmtree size={16} className="text-orange-300" /> Holiday Revision Pack
        <span className={`text-xs rounded-full px-2 py-0.5 ${f.full ? "bg-red-600" : "bg-green-600"}`} data-testid="holiday-on-sale">{f.full ? "FULLY BOOKED" : "BOOKING OPEN"}</span>
        <span className="text-xs text-slate-400 font-normal" data-testid="holiday-booked">{f.booked ?? 0}/{f.spots ?? 500} spots booked this season · {f.children ?? 0} child(ren) with a pack</span></p>
      {field("Price per child (Rs)", "price", "number")}
      {field("Minimum questions per subject (10-300; at least 5 per chapter)", "per_subject", "number")}
      {field("Next-year questions per subject (0-50; Grade 6: 10 PSAC prep)", "next_per_subject", "number")}
      {field("Spots per season", "spots", "number")}
      <p className="text-xs text-slate-400" data-testid="holiday-season-dates">Can be booked any time (first {f.spots} children). A new size applies when you rebuild a grade's pack in “Holiday Pack questions”. Access every year 15 Nov – 15 Jan. Current/next season: {f.sale_start} → {f.sale_end}. Monthly plans can be bought all year.</p>
      <button onClick={save} disabled={busy} className="rounded-full bg-orange-400 text-slate-900 px-4 py-2 text-sm font-bold" data-testid="holiday-settings-save">
        {busy ? <Loader2 size={14} className="animate-spin" /> : "Save"}
      </button>
    </div>
  );
}
